<template>
<v-row class="" v-if="this.$store.state.toggleItems">
  <v-col>
    <v-btn text block class="text-capitalize btn-left back-btn" @click="toggle();">
      <v-icon class="back-icon"></v-icon>
      Indietro
    </v-btn>
    <div class="item-intro mx-5 mb-9">
      <h2 class="item-title">{{this.$store.state.currentCat.title}}</h2>
      <p style="white-space: pre-line;" v-if="this.$store.state.currentCat.descr" class="item-title-descr">{{this.$store.state.currentCat.descr}}</p>
    </div>
    <div class="single-item mx-5" v-for="(item, index) in getItemById.items" :key="`items-${index}`" v-if="item.visibility != 'private'">
      <div v-if="item.type == 'Wine' || item.type == 'wine'  ">
        <p class="font-weight-semibold mb-1 secondary-color text-caption text-uppercase">{{item.region}}</p>
        <div class="d-flex justify-space-between text-subtitle-1 align-items-center">
          <div>
            <p class="font-weight-italic mb-1">{{item.title}}</p>
            <p class="font-weight-bold text-caption text-uppercase">{{item.brand}}</p>
          </div>
          <p class="pl-2">{{formatPrice(item.price)}}</p>
        </div>
        <p class="font-weight-light text-subtitle-2">{{item.descr}}</p>
      </div>
      <div v-else>
        <div class="d-flex justify-space-between">
          <p>{{item.title}}</p>
          <p v-if="item.price" class="pl-2">{{formatPrice(item.price)}}</p>
        </div>
        <p class="text-caption item-description">{{item.descr}}</p>
        <p class="item-footnote">{{item.footnote}}</p>
      </div>
    </div>
    </div>
  </v-col>

  <!-- <items-menu></items-menu> -->
</v-row>
</template>

<script>
export default {
  name: "ItemsMenu",
  data() {
    return {};
  },
  methods: {
    toggle() {
      this.$store.commit('setToggleCat');
      this.$store.commit('setToggleItems');
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  computed: {
    getItemById() {
      return this.$store.getters.getItemById(this.$store.state.currentCat.catId)
    }
  }
};
</script>
